import moment from "moment";

const UsersRow = ({ user }) => {


        let explodedName = user?.attributes?.name.split(' ');
        let initials = `${explodedName[0]?.charAt(0)}${explodedName[1]?.charAt(0)}`.toUpperCase();

        if(user?.attributes?.avatar){
            initials = <img className="avatar" style={{height: '35px', width: '35px'}} src={user?.attributes?.avatar} />
        }
        return (
            <div className="message-row shadow-sm align-items-end">
                <div className="namedLogo">
                    {initials}
                </div>
                <div className="message-text ">
                    <span className="username h5">{user?.attributes?.name}</span>
                </div>
                <div className="d-flex">
                    {/* <span className="date">{moment(user?.attributes?.createdAt).fromNow()}</span> */}
                </div>
            </div>
        )
};

export default UsersRow;